var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 39.4524,
    viewBox: "0 0 60 39.4524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ea5a47;}.cls-3{fill:#fff;}.cls-4{fill:#92d3f5;}.cls-5{fill:#b1cc33;}.cls-6{fill:#a57939;}.cls-2{stroke:#ea5a47;}.cls-2,.cls-7{stroke-linejoin:round;}.cls-2,.cls-7,.cls-8{stroke-linecap:round;stroke-width:2px;}.cls-7,.cls-8{fill:none;stroke:#000;}.cls-8{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.0753,
    y: 20.5056,
    width: 26.8836,
    height: 18.1139
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.2353 7.6524 33.1 20.4524 58.5 20.4524 45.2353 7.6524"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.3,10.4524l-6.4,6.0595V7.9386c0-.9313,.7549-1.4162,1.6862-1.4162h3.0276c.9313,0,1.6862,.4849,1.6862,1.4162v2.5138Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 38,
    y: 26.4524,
    width: 6,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 49,
    y: 26.4524,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.0059,12.7917c0-3.3123-3.4447-6.0025-7.6937-6.0025-.3549,.0029-.7095,.025-1.0622,.0662-1.7995-3.4553-5.7065-5.8554-10.2499-5.8554C10.7523,1,5.6879,5.5286,5.6879,11.1144c.0012,.3692,.0247,.738,.0704,1.1043-2.7927,.9002-4.7583,3.0439-4.7583,5.5473,0,3.3123,3.4446,6.0025,7.6936,6.0025,1.6151,.0139,3.2056-.4022,4.6137-1.207,1.8177,1.4766,4.7264,2.4385,8.0154,2.4385,5.5105,0,9.9776-2.6875,9.9776-6.0025-.0009-.2191-.0214-.4377-.0612-.6531,2.7966-.9016,4.7668-3.0467,4.7668-5.5527Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "41 11.4524 45.2353 7.4524 59 19.55 59 38.4524 33 38.4524 33 26.0006"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 38,
    y: 26.4524,
    width: 6,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 49,
    y: 26.4524,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "38.5 7.4524 41.5 7.4524 41.5 10.4524"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "17.5 38.4524 17.5 31.2793 12.5 26.4524"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 18.0408,
    y1: 31.1789,
    x2: 20.885,
    y2: 28.2181
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.0059,12.7917c0-3.3123-3.4447-6.0025-7.6937-6.0025-.3549,.0029-.7095,.025-1.0622,.0662-1.7995-3.4553-5.7065-5.8554-10.2499-5.8554C10.7523,1,5.6879,5.5286,5.6879,11.1144c.0012,.3692,.0247,.738,.0704,1.1043-2.7927,.9002-4.7583,3.0439-4.7583,5.5473,0,3.3123,3.4446,6.0025,7.6936,6.0025,1.6151,.0139,3.2056-.4022,4.6137-1.207,1.8177,1.4766,4.7264,2.4385,8.0154,2.4385,5.5105,0,9.9776-2.6875,9.9776-6.0025-.0009-.2191-.0214-.4377-.0612-.6531,2.7966-.9016,4.7668-3.0467,4.7668-5.5527Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 58.5,
    y1: 20.4524,
    x2: 37.5,
    y2: 20.4524
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.0f7781cf96be974c9d74194dd07213ca.svg";
export { ForwardRef as ReactComponent };